import { render, staticRenderFns } from "./SmsMessageManager.vue?vue&type=template&id=46c41d34"
import script from "./SmsMessageManager.vue?vue&type=script&lang=js"
export * from "./SmsMessageManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports